import React, { useEffect, useState } from "react";
import Index5CoinChart from "../../Dashboard/Index5/Index5CoinChart";
import { usePrices } from "../../../../context/SocketContext";

const CoinChart = ({ coin }) => {
  const prices = usePrices();
  const [price, setPrice] = useState(null);
  const [chartPrice, setChartPrice] = useState([]);
  const [percentChange, setPercentChange] = useState(null);
  const [volume24h, setVolume24h] = useState(null);
  const [marketCap, setMarketCap] = useState(null);
  const [color, setColor] = useState(null);

  useEffect(() => {
    if (coin) {
      setChartPrice(coin?.coinPriceHistory || []);
    }
  }, [coin]);

  useEffect(() => {
    if (!coin || !prices.length) return;

    const coinData = prices.find((item) => item.coinId === coin.id);
    if (coinData) {
      setPrice(coinData.price);
      setPercentChange(coinData.percentChange);
      setVolume24h(coinData.volume24h);
      setMarketCap(coinData.marketCap);
      setColor(
        coinData.color ||
          (coinData.price > coin?.coinPriceHistory?.[0]?.price
            ? "green"
            : "red")
      );
      setChartPrice((prev) => [...prev, coinData]);
    }
  }, [coin, prices]);

  return (
    <div className="card coin-content">
      <div className="card-header border-0 flex-wrap">
        <div className="mb-2">
          <h4 className="heading m-0">{coin?.name}</h4>
        </div>
      </div>
      <div className="card-body pt-0">
        {/* <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="d-flex justify-content-between flex-nowrap w-100 gap-3 flex-wrap-sm">
            <div className="price-content text-center flex-grow-1">
              <span className="fs-18 d-block mb-2">Price</span>
              <h4 className="fs-20 font-w600" style={{ color }}>
                {price || coin?.coinPriceHistory?.[0]?.price}
              </h4>
            </div>
            <div className="price-content text-center flex-grow-1">
              <span className="fs-14 d-block mb-2">24h% change</span>
              <h4 className="font-w600" style={{ color }}>
                {percentChange || coin?.coinPriceHistory?.[0]?.percentChange}
                <i
                  className={`fa-solid ms-1 ${
                    color === "green" ? "fa-caret-up" : "fa-caret-down"
                  }`}
                />
              </h4>
            </div>
            <div className="price-content text-center flex-grow-1">
              <span className="fs-14 d-block mb-2">Volume (24h)</span>
              <h4 className="font-w600">
                {volume24h || coin?.coinPrice[0]?.hourVolume}
              </h4>
            </div>
            <div className="price-content text-center flex-grow-1">
              <span className="fs-14 d-block mb-2">Market Cap</span>
              <h4 className="font-w600">
                {marketCap || coin?.coinPrice[0]?.marketCap}
              </h4>
            </div>
          </div>
        </div> */}
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="d-flex flex-wrap w-100 gap-3">
            <div className="price-content text-center flex-fill min-w-0">
              <span className="fs-18 d-block mb-2">Price</span>
              <h4 className="fs-20 font-w600" style={{ color }}>
                {price || coin?.coinPriceHistory?.[0]?.price}
              </h4>
            </div>
            <div className="price-content text-center flex-fill min-w-0">
              <span className="fs-14 d-block mb-2">24h% change</span>
              <h4 className="font-w600" style={{ color }}>
                {percentChange || coin?.coinPriceHistory?.[0]?.percentChange}
                <i
                  className={`fa-solid ms-1 ${
                    color === "green" ? "fa-caret-up" : "fa-caret-down"
                  }`}
                />
              </h4>
            </div>
            <div className="price-content text-center flex-fill min-w-0">
              <span className="fs-14 d-block mb-2">Volume (24h)</span>
              <h4 className="font-w600">
                {volume24h || coin?.coinPrice[0]?.hourVolume}
              </h4>
            </div>
            <div className="price-content text-center flex-fill min-w-0">
              <span className="fs-14 d-block mb-2">Market Cap</span>
              <h4 className="font-w600">
                {marketCap || coin?.coinPrice[0]?.marketCap}
              </h4>
            </div>
          </div>
        </div>

        <Index5CoinChart chartPrice={chartPrice} />

        <div className="d-flex align-items-center mt-4 justify-content-between flex-wrap">
          <div className="d-flex justify-content-between flex-nowrap w-100 gap-3 flex-wrap-sm">
            <div className="price-content text-center flex-grow-1">
              <span className="fs-14 d-block mb-2">Total Supply</span>
              <h4 className="font-w600">{coin?.totalSupply}</h4>
            </div>
            <div className="price-content text-center flex-grow-1">
              <span className="fs-14 d-block mb-2">Max Supply</span>
              <h4 className="font-w600">{coin?.maxSupply}</h4>
            </div>
            <div className="price-content text-center flex-grow-1">
              <span className="fs-14 d-block mb-2">Circulating Supply</span>
              <h4 className="font-w600">{coin?.circulatingSupply}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoinChart;
